import Col from "components/ui-elements/Col";
import React from "react";
import DropUploadMulti from "./DropUploadMulti";
const DropUploadMultiCol = (props) => {
  const { colsize, model, margin, ...rest } = props
  return (
    <Col size={colsize} model={model} margin={margin}>
      <DropUploadMulti {...rest} />
    </Col>
  );
};

DropUploadMultiCol.defaultProps = {
  colsize: 12,
  model: "md",
  margin: "mb-3"
}

export default DropUploadMultiCol;